'use client';

import { FC } from 'react';
import { NotFoundStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Container } from 'atoms/Container';
import { Picture } from 'atoms/Picture';
import { Body, HeadLine } from 'atoms/Typography/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { AppRoutes } from 'modules/shop/routes';
import { renderRichText } from 'modules/stroyblok/services';
import { getStoryblokUrl } from 'commerce/seo/utils';
import styles from './styles.module.css';

export const NotFound: FC<{ blok: NotFoundStoryblok }> = ({ blok }) => {
  const {
    title,
    subtitle,
    description,
    button,
    image,
    imageTablet,
    imageDesktop,
  } = blok;

  const link = button[0];
  const url = getStoryblokUrl(link.parameters);

  return (
    <Container className={styles.root}>
      <div className={styles.content}>
        <Body type="lg" tag="h1" className={styles.title}>
          {title}
        </Body>
        <HeadLine type="md" tag="h2" className={styles.subtitle}>
          <ReactMarkdown
            text={subtitle}
            components={{
              p: ({ children }) => (
                <Body
                  type="md"
                  weight="medium"
                  tag="span"
                  className={styles.textBlock}
                >
                  {children}
                </Body>
              ),
            }}
          />
        </HeadLine>
        <HeadLine type="xs" tag="p" className={styles.description}>
          <ReactMarkdown
            text={renderRichText(description) || ''}
            components={{
              p: ({ children }) => (
                <Body
                  type="md"
                  tag="span"
                  className={`${styles.textBlock} ${styles.textBlockSecond}`}
                >
                  {children}
                </Body>
              ),
            }}
          />
        </HeadLine>

        <Button
          color="purple"
          href={url === 'home' ? AppRoutes.HOME : url}
          className={styles.button}
        >
          {link.text}
        </Button>
      </div>
      <div className={styles.background}>
        <Picture
          srcDesktop={imageDesktop}
          srcTablet={imageTablet}
          srcMobile={image}
          className={styles.image}
        />
      </div>
    </Container>
  );
};
